import ComponentClass from "../utilities/ComponentClass";
class Modal extends ComponentClass.EventComponent {
    rootElement;
    id;
    #currentTarget = null;
    state = {
        visible: false
    };

    constructor({element}) {
        super();
        this.rootElement = element.firstElementChild.cloneNode(true);
        this.id = element.id;
        this.main();
    }
    main() {
        this.attachClickListeners();
        this.rootElement.setAttribute('modal-control', this.id);
    }
    attachClickListeners() {
        for (const modalButton of document.querySelectorAll('[data-toggle="modal"]')) {
            modalButton.addEventListener('click', (event) => this.handleButtonClick(event), false);
        }
        const closeButton = this.rootElement.querySelector('.modal-content__header__close');
        if (closeButton !== null) {
            closeButton.addEventListener('click', () => this.close(), false);
        }
    }

    handleButtonClick({currentTarget}) {
        if (!this.#checkModalTargetValidity(currentTarget)) return;
        this.setState({visible: currentTarget.dataset.target === this.id});
        this.toggle();
    }

    toggle() {
        this.state.visible ? this.open() : this.close();
    }

    async open() {
        await this.renderModal();
        this.setState({visible: true});
        this.emit();
    }

    async close() {
        await this.destroyModal();
        this.setState({visible: false});
        this.emit();
    }

    emit() {
        this.dispatchEvent(
            new CustomEvent('modal.state', {
                detail: {
                    state: this.state,
                    id: this.id
                }
            })
        )
    }

    renderModal() {
        const appElement = document.getElementById('app');
        return new Promise((resolve) => {
            const exist = appElement.querySelector(`[modal-control="${this.id}"]`);
            if (exist !== null) {
                resolve();
                return;
            }
            appElement.appendChild(this.rootElement);
            setTimeout(() => {
                document.body.classList.add('modal-opened');
                resolve();
            }, 100);
        });
    }

    destroyModal() {
        return new Promise((resolve) => {
            document.body.classList.remove('modal-opened');
            setTimeout(() => {
                this.rootElement.remove()
                resolve();
            }, 500);
        });
    }

    #checkModalTargetValidity(currentTarget) {
        if (currentTarget.dataset.hasOwnProperty('target')) {
            return true;
        } else {
            throw new Error('Modal button element controller must have an attribute data-target="{modalId}" with a value of the modal id')
        }
    }
}

function handleModal({detail}) {
    // console.log('visible: ', detail.state, ': ' , detail.id);
}

export default function useModal() {
    for (const modelElement of document.querySelectorAll('.modal')) {
        const modalInstance = new Modal({
            element: modelElement
        });
        modalInstance.addEventListener('modal.state', handleModal, false);
    }
}
